import { ComponentMapData, LibraryMetaData } from "./meta-data";
import { buildComponents, assetBundle, AssetLevel, AssetLoader } from '@alilc/lowcode-utils';
import { BeflamComponentLibMeta } from "./beflam-component-lib-meta";
import packageBase from "./package-base";
import { UserList } from "../pages/User/UserList";
import EditUser from "../pages/User/EditUser";
import { DepList } from "../pages/Department/DepList";
import { AllFunctions } from "../pages/allfunctions";
import DataSetManager from "../pages/DataSets/dataManager";
import MyIssueList from "../pages/Issue/MyIssueList";
import { FileManager } from "../pages/FileManager/fileList";

export class LibraryManager {
    // 由于目前暂时使用字包含的模式，package缓存用不上
    // private packageLibs: Record<string, PackageData> = {}
    // private static componentLibs: Record<string, any> = {}

    // packageContainer(name: string): boolean {
    //     return !!this.packageLibs[name]
    // }
    static isInited: boolean = false
    static components: Record<string, any>

    // static componentContainer(name: string): boolean {
    //     return !!this.componentLibs[name]
    // }

    static async init(metaDatas: BeflamComponentLibMeta) {
        if (LibraryManager.isInited) {
            return
        }
        LibraryManager.isInited = true
        for (const key in metaDatas) {
            const lib = metaDatas[key]
            try {
                const libData = await LibraryManager.analizeComponentLib(lib);
                packageBase.packages = packageBase.packages.concat(libData.packages);
                packageBase.components = packageBase.components.concat(libData.components);
            } catch (err) {
                console.error(err)
                console.error(`组件库：${lib.Name} 加载失败`)
            }

        }

        // const beflamIndex = packageBase.packages.findIndex((val) => val.package === 'lowcode-beflam');
        // if (beflamIndex === -1) {
        //     packageBase.packages.push(
        //         {
        //             "package": "lowcode-beflam",
        //             "version": "0.1.5",
        //             "library": "BeflamLayout",
        //             "urls": [
        //                 "https://resource.designer.beflam.com/beflam-layout/0.1.5/dist/BeflamLayout.js",
        //                 "https://resource.designer.beflam.com/beflam-layout/0.1.5/dist/BeflamLayout.css"
        //             ],
        //             "editUrls": [
        //                 "https://resource.designer.beflam.com/beflam-layout/0.1.5/build/lowcode/view.js",
        //                 "https://resource.designer.beflam.com/beflam-layout/0.1.5/build/lowcode/view.css"
        //             ]
        //         }
        //     );

        //     packageBase.components.push(
        //         {
        //             "exportName": "LowcodeBeflamMeta",
        //             "npm": {
        //                 "package": "lowcode-beflam",
        //                 "version": "0.1.5"
        //             },
        //             "url": "https://resource.designer.beflam.com/beflam-layout/0.1.5/build/lowcode/meta.js",
        //             "urls": {
        //                 "default": "https://resource.designer.beflam.com/beflam-layout/0.1.5/build/lowcode/meta.js",
        //                 "design": "https://resource.designer.beflam.com/beflam-layout/0.1.5/build/lowcode/meta.design.js"
        //             }
        //         }
        //     );
        // }
        // const fusionIndex = packageBase.packages.findIndex((val) => val.package === '@bef/lowcode-fusion');
        // if (fusionIndex === -1) {
        //     packageBase.packages.push(
        //         {
        //             "package": "@bef/lowcode-fusion",
        //             "version": "0.1.42",
        //             "library": "BefFusion",
        //             "urls": [
        //                 "https://resource.designer.beflam.com/lowcode-fusion/0.1.42/dist/BefFusion.js",
        //                 "https://resource.designer.beflam.com/lowcode-fusion/0.1.42/dist/BefFusion.css"
        //             ],
        //             "editUrls": [
        //                 "https://resource.designer.beflam.com/lowcode-fusion/0.1.42/build/lowcode/view.js",
        //                 "https://resource.designer.beflam.com/lowcode-fusion/0.1.42/build/lowcode/view.css"
        //             ]
        //         }
        //     );

        //     packageBase.components.push(
        //         {
        //             "exportName": "BefLowcodeFusionMeta",
        //             "npm": {
        //                 "package": "@bef/lowcode-fusion",
        //                 "version": "0.1.42"
        //             },
        //             "url": "https://resource.designer.beflam.com/lowcode-fusion/0.1.42/build/lowcode/meta.js",
        //             "urls": {
        //                 "default": "https://resource.designer.beflam.com/lowcode-fusion/0.1.42/build/lowcode/meta.js",
        //                 "design": "https://resource.designer.beflam.com/lowcode-fusion/0.1.42/build/lowcode/meta.design.js"
        //             }
        //         }
        //     );
        // }

        // todo component解析
        let allComponents: ComponentMapData[] = []
        for (const comp of packageBase.components) {
            // if (comp.exportName === 'LowcodeBeflamMeta') {
            //     allComponents = allComponents.concat(beflameComponents)
            // } else {
            //     await LibraryManager.loadScript(comp.url)
            //     const metaData = LibraryManager.analyzeMeta(comp.exportName)
            //     // this.componentLibs[comp.exportName] = metaData
            //     allComponents = allComponents.concat(metaData)
            // }

            await LibraryManager.loadScript(comp.url)
            const metaData = LibraryManager.analyzeMeta(comp.exportName)
            // this.componentLibs[comp.exportName] = metaData
            allComponents = allComponents.concat(metaData)
        }

        const components = await LibraryManager.loadComponentsAsync(allComponents, packageBase.packages)
        components.BefUserList = UserList;
        components.BefEditUser = EditUser;
        components.BefDepList = DepList;
        components.BefAllFunction = AllFunctions;
        components.BefFileManager = FileManager;
        components.MyIssueList = MyIssueList;
        components.BefDataSetManager=DataSetManager;
        // console.log(components)
        LibraryManager.components = components
    }

    static async analizeComponentLib(lib: { Package: string }) {
        const url = `${lib.Package}/build/lowcode/assets-prod.json`
        const assets = await (await fetch(url)).json();
        const resault = {
            packages: [] as any[],
            components: [] as any[]
        }
        for (const pac of assets.packages) {
            resault.packages.push(
                {
                    "package": pac.package,
                    "version": pac.version,
                    "library": pac.library,
                    "urls": [
                        `${lib.Package}/dist/${pac.library}.js`,
                        `${lib.Package}/dist/${pac.library}.css`
                    ],
                    "editUrls": [
                        `${lib.Package}/build/lowcode/view.js`,
                        `${lib.Package}/build/lowcode/view.css`
                    ]
                }
            )
        }

        for (const com of assets.components) {
            resault.components.push(
                {
                    "exportName": com.exportName,
                    "npm": {
                        "package": com.npm.package,
                        "version": com.npm.version
                    },
                    "url": `${lib.Package}/build/lowcode/meta.js`,
                    "urls": {
                        "default": `${lib.Package}/build/lowcode/meta.js`,
                        "design": `${lib.Package}/build/lowcode/meta.design.js`
                    }
                }
            )
        }
        return resault
    }

    // async loadPackage(name: string) {
    //     if (!LibraryManager.componentContainer(name)) {
    //         const ad = await LibraryManager.loadMeta(name);
    //         console.log(`获取AssetData:${JSON.stringify(ad)}`)

    //         // pakcgae 和 component 分开解析
    //         // todo package解析
    //         // for (const pack of ad.packages) {
    //         //     //暂时只要比对是否存在，不验证版本号
    //         //     //这样就是谁先进，谁说了算
    //         //     if (!this.packageContainer(pack.package)) {
    //         //         for (const url of pack.urls) {
    //         //             const segs = url.split('.');
    //         //             const ext = segs[segs.length - 1]
    //         //             if (ext === 'js') {
    //         //                 await LibraryManager.loadScript(url)
    //         //             } else {
    //         //                 await LibraryManager.loadCss(url)
    //         //             }
    //         //         }
    //         //     }
    //         // }

    //         // todo component解析
    //         let allComponents: ComponentMapData[] = []
    //         for (const comp of ad.components) {
    //             await LibraryManager.loadScript(comp.url)
    //             const metaData = LibraryManager.analyzeMeta(comp.exportName)
    //             // this.componentLibs[comp.exportName] = metaData
    //             allComponents = allComponents.concat(metaData)
    //         }

    //         const components = await LibraryManager.loadComponentsAsync(allComponents, fusionPackages.packages)
    //         LibraryManager.componentLibs[name] = components
    //     }
    // }

    // private static completeMetaUrl(name: string): string {
    //     // todo 完成由组件库名称等信息解析meta的url地址
    //     return 'https://resource.designer.beflam.com/test/assets-prod-qiniu.json'
    //     return name
    // }

    // private static async loadMeta(name: string): Promise<AssetData> {
    //     const url = LibraryManager.completeMetaUrl(name);
    //     const resp = await fetch(url);
    //     return await resp.json()
    // }

    /**
     * 加载js脚本
     * todo meta加载测试
     * todo component加载测试
     * @param url 
     * @returns 
     */
    private static loadScript(url: string): Promise<void> {
        return new Promise<void>((resolve: () => void, reject: (reason?: any) => void) => {
            const src = ((_url) => {
                const isInFileProtocol = _url.indexOf('//') === 0 && window.location.protocol === 'file:';
                return isInFileProtocol ? `//${_url}` : _url;
            })(url);
            const scriptElement = document.createElement('script');
            scriptElement.crossOrigin = 'anonymous';
            scriptElement.src = src;
            scriptElement.async = true;
            scriptElement.onload = () => resolve();
            scriptElement.onerror = () => reject(new Error(`Inject ${url} failed`));
            document.body.insertBefore(scriptElement, document.body.firstChild);
        })
    }

    // todo 缺少加载css的代码
    private static loadCss(url: string): Promise<void> {
        return new Promise<void>((resolve: () => void, reject: (reason?: any) => void) => {

        })
    }

    /**
     * 解析meta脚本
     * todo 
     */
    private static analyzeMeta(name: string): ComponentMapData[] {
        if (window[name]) {
            const result: ComponentMapData[] = []
            const metaData: LibraryMetaData = window[name];
            for (const component of metaData.components) {
                result.push({
                    package: component.npm.package,
                    version: component.npm.version,
                    exportName: component.npm.exportName,
                    main: component.npm.main,
                    destructuring: component.npm.destructuring,
                    subName: component.npm.subName,
                    componentName: component.componentName
                })
            }

            return result
        } else {
            throw new Error(`未能加载${name}`)
        }
    }

    private static async loadComponentsAsync(componentsMapArray: any[], packages: any[]): Promise<Record<string, any>> {
        // 动态加载主要是依靠 @alilc/lowcode-utils ，来完成的。

        const componentsMap: any = {};// 中间数据结构
        componentsMapArray.forEach((component: any) => {
            componentsMap[component.componentName] = component;
        });

        // 包相关
        const libraryMap: any = {};
        const libraryAsset: any[] = [];
        packages.forEach(({ package: _package, library, urls, renderUrls }) => {
            libraryMap[_package] = library;
            if (renderUrls) {
                // 这里应该是设计view层组件才有的
                libraryAsset.push(renderUrls);
            } else if (urls) {
                // 这里应该是生产层的组件的
                libraryAsset.push(urls);
            }
        });

        assetBundle(libraryAsset, AssetLevel.Library)

        const assetLoader = new AssetLoader();
        await assetLoader.load(libraryAsset);// 加载依赖资源包

        const components = buildComponents(libraryMap, componentsMap, () => null);
        return components;
    }
}